import type { FC } from 'react';
import type { SmallMenuItem } from '@/types/menu';
import { MegaMenuLinkWrapper } from '@/components/raven/MegaMenu/MegaMenuLinkWrapper';

import styles from './styles.module.css';

export const MegaMenuHorizontalGroup: FC<{
	child: SmallMenuItem;
}> = ({ child }) => {
	const children = child.children || [];
	const hasChildren = Boolean(children);

	if (!hasChildren) {
		return null;
	}

	return (
		<ul className={styles.menuHorizontalGroup}>
			{children.map((subChild) => (
				<MegaMenuLinkWrapper child={subChild} key={subChild.id} />
			))}
		</ul>
	);
};
